<template>
  <div>
    <v-btn color="indigo" class="mb-2" block dark @click.stop="dialog = true">
      Galéria
    </v-btn>

    <v-dialog v-model="dialog" max-width="600">
      <app-carousel></app-carousel>
    </v-dialog>
  </div>
</template>

<script>
import Carousel from "@/components/home/Modal/Carousel";

export default {
  components: {
    "app-carousel": Carousel
  },
  data() {
    return {
      dialog: false
    };
  }
};
</script>
